import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

// Search params of the Security Checklist copy-source picker (CD-5407). The eligible sources are decided
// server-side (this client's won Opportunities with a completed checklist) and are few, so the picker filters
// the loaded rows in place - this only carries what to filter on.
class ChecklistCopySourceSearchParams extends SearchParamsBase {
  static saveType = 'ChecklistCopySourceSearchParams';
  static iconName = 'fa-solid fa-search';

  initialize() {
    this.OpportunityIdOrName = '';
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'OpportunityIdOrName',
      label: 'Opportunity Id or Name',
      className: 'col-12',
      type: InputTypesEnum.Text,
    },
  ];
}

export default ChecklistCopySourceSearchParams;
